import React, {useEffect} from "react";
import ButtonDelete from "components/buttons/ButtonDelete";
import Upload from "components/Upload";
import AgreementsSelect from "./AgreementsSelect";
import EditSelect from "components/selects/EditSelect";
import {CollectiveUnionAgreementsOrganizationTypes} from "constants/presentationPage.consts";
import {inject, observer} from "mobx-react";

const CollectiveUnionAgreementsForm = inject("store")(
  observer(({store: {organization}, index, remove, unionAgreement, setFieldValue}) => {
    const fileFieldName = `unionAgreements.${index}.Files`;
    const organizationFieldName = `unionAgreements.${index}.organizationName`;
    const localAgreementName = `unionAgreements.${index}.localAgreement`;
    const organizationTypeName = `unionAgreements.${index}.organizationType`;

    const handleChangeOrganizationType = (value) => {
      setFieldValue(
        organizationFieldName,
        value === "collective"
          ? "LOCAL_AGREEMENT_ORGANIZATION_NAME_DEFAULT"
          : "COLLECTIVE_AGREEMENT_ORGANIZATION_NAME_DEFAULT"
      );
      setFieldValue(localAgreementName, value === "locale");
    };

    useEffect(() => {
      setFieldValue(
        organizationTypeName,
        unionAgreement.localAgreement ? "locale" : "collective"
      );
    }, [organizationTypeName, unionAgreement.localAgreement, setFieldValue]);

    return (
      <div className="editBlock_item">
        <div className="editBlock_flex__wrap without-labels">
          <EditSelect
            list={CollectiveUnionAgreementsOrganizationTypes}
            name={organizationTypeName}
            onChange={handleChangeOrganizationType}
          />

          <AgreementsSelect values={unionAgreement} name={organizationFieldName} value />

          <Upload
            uploadRequest={organization.unionAgreementUploadFile}
            files={unionAgreement.Files}
            onChange={(files) => setFieldValue(fileFieldName, files)}
            filenameMaxViewLength={{edit: 40}}
          />

          <ButtonDelete addClass="editBlock_btn__clean" onClick={() => remove(index)} />
        </div>
      </div>
    );
  })
);

export default CollectiveUnionAgreementsForm;
